export default __webpack_public_path__ + "static/media/alex4.493c0f45.jpg";